<template>
  <div class="country-info-wrapper" v-click-outside="outClose">
    <span
      v-if="!client.country"
      class="client-country"
    >—</span>
    <span
      v-if="client.country"
      @mouseover="showAreaPopup = true"
      @mouseleave="showAreaPopup = false"
      class="client-country"
    >
      <img
        @click="prepareMap"
        class="country-flag"
        :src="
          '/img/flags/' + client.country.alpha2.toLowerCase() + '.png'
            ? '/img/flags/' + client.country.alpha2.toLowerCase() + '.png'
            : ''
        "
      />

      <!-- -->
      <span
        class="text-size"
        @click="
          $emit('edit');
          showAreaPopup = false;
        "
      >
        {{ client.country.alpha2 | truncate(8) }}</span
      >
    </span>
    <template v-if="client.country">
    <span
      @mouseenter="showTimeDiffPopUp = true"
      @mouseleave="showTimeDiffPopUp = false"
      :class="{
        minusDiff: timeDiff(client.country.current_time) < 0,
        'time-diff': timeDiff(client.country.current_time) > 0,
        'time-equal': timeDiff(client.country.current_time) == 0
      }"
    >
      {{
        corectFormat(client.country.time_zone) !== " "
          ? corectFormat(client.country.time_zone)
          : 0
      }}
    </span>
    <div v-if="showTimeDiffPopUp" class="time-diff-pop-up">
      {{ corrctTime(client.country.current_time) | shortTime }}
    </div>

    <div v-if="showAreaPopup" class="country-area-popup">
      {{ client.country.name }} | {{ client.country.area_code_main }} | Tier
      {{ client.country.tier }} |
      {{ corrctTime(client.country.current_time) | shortTime }}
    </div>
    </template>

    <div
      v-if="showAreaPopup && client.last_ip !== null"
      class="country-ip-popup"
    >
      <table class="table">
        <tbody>
          <tr>
            <td>{{ byIpObj.ip }}</td>
            <td>{{ byIpObj.country_code2 }}</td>
            <td>{{ byIpObj.state_prov }}</td>
            <td>{{ byIpObj.city }}</td>
            <td>{{ byIpObj.zipcode }}</td>
            <td>{{byIpObj.currency? byIpObj.currency.code:'' }} {{byIpObj.currency? byIpObj.currency.symbol:'' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="showCountryMap" class="country-map">
      <GmapMap
        :center="{ lat: coords.lat, lng: coords.lng }"
        :zoom="7"
        map-type-id="terrain"
        style="width: 500px; height: 300px"
        :options="{
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: true,
          rotateControl: true,
          fullscreenControl: true,
          disableDefaultUi: false
        }"
      >
        <GmapMarker
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          :clickable="true"
          :draggable="true"
          @click="center = m.position"
        />
      </GmapMap>
    </div>
  </div>
</template>
<!--<div class="tag-table">
  <div v-if="showAreaPopup" class="table-responsive">
    <table class="table table-condensed">
      <tbody>
      <tr>
        <td> {{country.name}}</td>
        <td>{{country.area_code_main}}</td>
        <td>Tier {{country.tier}}</td>
      </tr>
      </tbody>
    </table>

  </div>
</div>
</div>-->

<script>
import moment from "moment";
import { gmapApi } from "vue2-google-maps";
import ClickOutside from "vue-click-outside";
import apiClientCreator from "../../../../../helpers/api/request";
import IPGeolocationAPI from "ip-geolocation-api-javascript-sdk";

export default {
  name: "ClientCountyInfo",
  computed: {
    google: gmapApi
  },
  props: {
    client: {
      type: Object,
      required: true
    }
  },
  directives: {
    ClickOutside
  },

  created() {
    // this.getGeoCode();
    // this.getIpToLocation(); // API key expired - disabled
  },
  data() {
    return {
      showAreaPopup: false,
      showCountryMap: false,
      coords: {
        lat: null,
        lng: null
      },
      byIpObj: {},
      showTimeDiffPopUp: false
    };
  },
  mounted() {},
  methods: {
    corectFormat(rowTime) {
      if (!rowTime) return '0';
      let temp = rowTime.substr(0, 3);
      if (temp.includes("0")) {
        temp = temp.replace("0", " ");
      }
      if (temp.includes(":")) {
        temp = temp.replace(":", " ");
      }
      return temp;
    },
    timeDiff(countryTime) {
      if (!countryTime) return 0;
      // const now = moment().subtract(2, "hours"); //todays date
      const now = moment().tz("Europe/London"); //todays date
      // let forgenCountry = moment(countryTime, "HH:mm").subtract(2, "hours");
      let forgenCountry = moment(countryTime, "HH:mm");
      let duration = moment.duration(forgenCountry.diff(now));
      let hours = duration.asHours();

      return hours.toFixed(0);
      // let total =
      //
      //   parseInt(forgenCountry.format("hh:mm")) - parseInt(now.format("hh:mm"));
      // return total;
      // return (total>0 ?'+'+total:total<0?total:'');
    },
    outClose() {
      this.showCountryMap = false;
    },
    corrctTime(time) {
      if (!time) return moment();
      return moment(time, "HH:mm").subtract(2, "hours"); //moment([time]).subtract(3,'hours')
    },
    prepareMap() {
      this.getGeoCode();
    },

    async getGeoCode() {
      //  this.$store.commit("clients/setLoading", true);
      // let locPhisMs;
      // if (this.client.loc_physical_ms === null) {
      //   locPhisMs = "";
      // } else {
      //   const reqCriteria = apiClientCreator(
      //     `client/city/${this.client.loc_physical_ms}`
      //   );
      //   locPhisMs = await reqCriteria.get("");
      // }

      this.$geocoder.setDefaultMode("address"); // this is default
      const addressObj = {
        //  address_line_1: "1600 Amphitheatre Parkway",
        //address_line_2: "",

        city:
          this.client.lead_loc && this.client.lead_loc.length > 3
            ? this.checkIfMoon(this.client.lead_loc)
            : "",
        // city:
        //   locPhisMs.data && locPhisMs.data[0].length > 3
        //     ? locPhisMs.data[0]
        //     : "",
        //

        //state:          'CA',
        // zip_code: "94043",
        country: this.client.country.name
      };
      this.$geocoder.send(addressObj, response => {
        //console.log(response);
        this.coords.lat = response.results[0].geometry.location.lat;
        this.coords.lng = response.results[0].geometry.location.lng;
        this.showCountryMap = true;
      });
      //  this.$store.commit("clients/setLoading", false);
    },

    getIpToLocation() {
      if (this.client.last_ip !== null) {
        const ipgeolocationApi = new IPGeolocationAPI(
          "18a036382714417c83ad3b90936787b7",
          false
        );
        const GeolocationParams = require("ip-geolocation-api-javascript-sdk/GeolocationParams.js");
        const geolocationParams = new GeolocationParams();
        geolocationParams.setIPAddress(this.client.last_ip);
        geolocationParams.setFields("geo,time_zone,currency");

        ipgeolocationApi.getGeolocation(this.handleResponse, geolocationParams);
      }
    },
    handleResponse(json) {
      //   console.log(json)
      this.byIpObj = json;
    },
    checkIfMoon(moon) {
      if (moon === "Moon") {
        return this.byIpObj.city;
      }
      if (moon === "") {
        return "";
      }
    }
  }
};
</script>

<style scoped>
html * {
  font-family: "Montserrat" !important;
  font-size: 13px;
}

.country-info-wrapper {
  position: relative;
}
.time-diff-pop-up {
  position: absolute;
  padding: 2px;
  bottom: 16px;
  left: 51px;
  z-index: 10001;
  width: max-content;
  border-radius: 5px;
  background-color: #fff;
  border: solid 1px #4d4f50;
  /*  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);*/
  font-family: Montserrat;
}

.country-area-popup {
  position: absolute;
  padding: 8px;
  bottom: 24px;
  left: 0px;
  z-index: 10001;
  width: max-content;
  border-radius: 5px;
  background-color: #fff;
  border: solid 1px #4d4f50;
  /*  -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);*/
  font-family: Montserrat;
}

.country-ip-popup {
  position: absolute;
  padding: 8px;
  bottom: 66px;
  left: 0px;
  z-index: 10001;
  border: solid 1px #4d4f50;
  width: max-content;
  /*  border-radius: 5px;*/
  background-color: #fff;
  /*  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);*/
  z-index: 1500009;
}

.country-map {
  position: absolute;
  padding: 8px;
  /*bottom: 24px;*/
  top: -8px;
  right: 90px;
  z-index: 10001;
  border: solid 1px #90a4ae;
  width: max-content;
  height: max-content;
  /*  border-radius: 5px;*/
  background-color: #fff;
  /*  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);*/
}

.client-country {
  margin-left: 2px;
  cursor: pointer;
  font-size: 12px !important;
}
.country-flag:hover {
  border: 1px solid white;
}
.country-flag {
  margin-top: -2px;
  border-radius: 3px;
  margin-left: 5px;
}

.country-clock {
  font-size: 8pt;
  margin-left: 5px;
}

.table {
  margin-bottom: 0px;
}
.text-size {
  font-size: 9px;
  padding-left: 2px;
  /*font-weight: 700;*/
}
.country-info-wrapper span {
  font-size: 12px;
}
.time-diff {
  /*position: absolute;*/
  /*left: 53px;*/
  /*top: 2px;*/
  float: right;
  margin-top: 2px;
  font-size: 13px !important;
  color: #1bc51b;
  font-weight: 700;
  font-family: "digital" !important;
  cursor: pointer;
}
.minusDiff {
  /*position: absolute;*/
  /*left: 53px;*/
  /*top: 2px;*/
  float: right;
  margin-top: 2px;
  font-size: 13px !important;
  color: #e06868;
  font-weight: 700;
  font-family: "digital" !important;
  cursor: pointer;
}
.time-equal {
  cursor: pointer;
  float: right;
  margin-top: 2px;
  font-size: 13px !important;
  color: orange;
  font-weight: 700;
  font-family: "digital" !important;
}
</style>
